var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import SearchField from "../../../Form/SearchField";
import { PersonSearch } from "../../Person/PersonSearch";
import PersonService from "../../../../Services/Person.service";
export const PERSON_LOADER_GET_CRITERIA = (formState) => ({
    delegates: [],
    criteria: {
        personId: { value: formState.person.personId },
    },
});
export const PERSON_LOADER_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    return {
        person: (yield PersonService.getPeopleByPersonId(criteria.personId.value))[0],
    };
});
const PersonLoaderWorkflowNodeDefinitionForm = ({ name }) => (_jsx(_Fragment, { children: _jsx(SearchField, { label: "Person", name: name + ".person", required: true, as: (provided) => _jsx(PersonSearch, Object.assign({}, provided)) }) }));
export default PersonLoaderWorkflowNodeDefinitionForm;
